module.exports = __webpack_public_path__ + "static/img/GM.d01a8ce4.svg";